<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="boxes" />
          {{ $t('product') }}
        </h1>
      </div>
    </div>
    <product-list></product-list>
  </main>
</template>

<script>
import ProductList from '@/views/ecommerce/ProductList.vue'

export default {
  components: { ProductList },
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        product: 'Product'
      },
      vi: {
        product: 'Sản phẩm'
      }
    }
  }
}
</script>